import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountingService } from '../../../services/accounting.service';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { DrawerModule } from 'primeng/drawer';

@Component({
  selector: 'app-accounting-contacts',
  standalone: true,
  imports: [CommonModule, TableModule, ButtonModule, TagModule, DrawerModule],
  template: `
    <div class="p-4">
      <div class="flex justify-content-between align-items-center mb-4">
        <h1 class="text-3xl font-bold m-0 text-primary">Contacts</h1>
        <p-button label="Add Contact" icon="pi pi-plus" size="small"></p-button>
      </div>

      <p-table [value]="contacts" [rows]="10" [paginator]="true" styleClass="p-datatable-striped shadow-2 border-round overflow-hidden" selectionMode="single" (onRowSelect)="onContactSelect($event.data)">
        <ng-template pTemplate="header">
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Email</th>
            <th class="text-right">Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-con>
          <tr [pSelectableRow]="con" class="cursor-pointer">
            <td class="font-bold">{{ con.name }}</td>
            <td>
              <p-tag [value]="con.type | uppercase" [severity]="con.type === 'customer' ? 'success' : 'info'"></p-tag>
            </td>
            <td>{{ con.email }}</td>
            <td class="text-right">
              <p-button icon="pi pi-history" [text]="true" label="History" size="small" (onClick)="onContactSelect(con)"></p-button>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!-- History Drawer -->
      <p-drawer [(visible)]="displayHistory" position="right" [style]="{width: '500px'}" header="{{ selectedContact?.name }} - Transaction History">
        <div *ngIf="contactTransactions.length === 0" class="p-5 text-center text-500">
          <i class="pi pi-info-circle text-4xl mb-3"></i>
          <p>No transactions found for this contact.</p>
        </div>
        
        <p-table *ngIf="contactTransactions.length > 0" [value]="contactTransactions" styleClass="p-datatable-sm">
          <ng-template pTemplate="header">
            <tr>
              <th>Date</th>
              <th>Description</th>
              <th class="text-right">Amount</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-tx>
            <tr>
              <td>{{ tx.date | date:'shortDate' }}</td>
              <td>{{ tx.description }}</td>
              <td class="text-right font-bold">{{ tx.amount | currency }}</td>
            </tr>
          </ng-template>
        </p-table>
      </p-drawer>
    </div>
  `
})
export class ContactsComponent implements OnInit {
  contacts: any[] = [];
  selectedContact: any = null;
  contactTransactions: any[] = [];
  displayHistory = false;

  constructor(private accountingService: AccountingService) { }

  ngOnInit() {
    this.accountingService.getContacts().subscribe(data => this.contacts = data);
  }

  onContactSelect(contact: any) {
    this.selectedContact = contact;
    this.displayHistory = true;
    this.contactTransactions = [];

    this.accountingService.getTransactions({ contactId: contact.id }).subscribe(allTxs => {
      // In a real API, the filters would handle this. 
      // For mock purposes, if the API doesn't filter, we filter manually.
      this.contactTransactions = allTxs.filter((tx: any) => tx.contact_id === contact.id || tx.id === 'tx-1'); // Mock logic
    });
  }
}

